import React, { PureComponent } from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';

const BlockRow = styled('div')({
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    height: 60,
    marginBottom: 5,
    // borderLeft: selected && `5px solid ${ Theme.colors.skyBlue }`,
    boxShadow: "0 1px 2px rgb(0 0 0 / 15%)",
    '&:hover': {
        filter: "brightness(97%)"
    }
});

const NameBlock = styled('div')({
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: "0 20px",
    backgroundColor: Theme.colors.lightBlue
});


class BookletRow extends PureComponent {
    state = {
        anchorEl: null
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: false });
    };

    render() {
        const { isHeader, canWrite, onSelect, replace, upload, generateAutomated, previewManual, setStatus, item } = this.props;

        const styles = {
            headerBlockRow: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                height: 30,
                marginBottom: 5
            },
            blockRowBody: {
                display: 'flex',
                flex: 3,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end'
            },
            blockRowSelected: {
                borderLeft: `5px solid ${ Theme.colors.skyBlue }`
            },
            nameBlock: {
                flex: 1,
                display: 'flex',
                alignItems: 'flex-start',
                backgroundColor: Theme.colors.lightBlue,
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                padding: "0 20px"
            },
            data: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'end',
                marginLeft: 'auto'
            },
            block: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }
        };

        if (isHeader) {
            return (
                <div style={styles.headerBlockRow}>
                    <div style={{ ...styles.nameBlock, backgroundColor: Theme.colors.backgroundGrey, padding: "0 15px" }}>
                        <Text small bold>Class</Text>
                    </div>

                    <div style={ styles.blockRowBody }>
                        <div style={styles.block}>
                            <Text small bold>Manual Booklet Uploaded</Text>
                        </div>

                        <div style={styles.block}>
                            <Text small bold>Using Automated Booklets</Text>
                        </div>

                        <div style={styles.block}>
                            <Text small bold>Booklet Type</Text>
                        </div>

                        <div style={{ width: 50 }} />
                    </div>
                </div>
            );
        }

        const { title, description, useAutoBooklet, hasBooklet } = item;

        return (
            <BlockRow onClick={ onSelect }>

                <NameBlock>
                    <Text medium>{ title }</Text>
                    <Text
                        color={ Theme.colors.darkBlue }
                        tiny
                    >
                        { description }
                    </Text>
                </NameBlock>

                <div style={ styles.blockRowBody }>
                    <div style={styles.block} >
                        <Text medium light>
                            { hasBooklet ? 'Uploaded' : 'No' }
                        </Text>
                    </div>

                    <div style={styles.block} >
                        <Text medium light>
                            { useAutoBooklet ? 'Yes' : 'No' }
                        </Text>
                    </div>

                    <div style={styles.block} >
                        <Text medium light>
                            { !hasBooklet && !useAutoBooklet ? 'None' : useAutoBooklet ? 'Automated' : 'Manual' }
                        </Text>
                    </div>
                </div>

                {
                    canWrite &&
                        <div>
                            <IconButton aria-label="Edit" onClick={this._handleMenuClick} style={{ width: 48, height: 48, color: Theme.colors.mainTextGrey }}>
                                <MoreVertIcon style={{ color: Theme.colors.mainTextGrey }}/>
                            </IconButton>

                            <Menu
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this._handleCloseMenu}
                                disableAutoFocusItem={true}
                                style={styles.menu}
                            >
                                {
                                    hasBooklet === 1 &&
                                        <MenuItem
                                            onClick={ () => {
                                                this._handleCloseMenu();
                                                previewManual();
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Preview Manual Booklet
                                            </Text>
                                        </MenuItem>
                                }

                                {
                                    hasBooklet === 1 ?
                                        <MenuItem
                                            onClick={ () => {
                                                this._handleCloseMenu();
                                                replace();
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Replace Manual Booklet
                                            </Text>
                                        </MenuItem>
                                        :
                                        <MenuItem
                                            onClick={ () => {
                                                this._handleCloseMenu();
                                                upload();
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Upload Booklet
                                            </Text>
                                        </MenuItem>
                                }

                                <MenuItem
                                    onClick={ () => {
                                        this._handleCloseMenu();
                                        generateAutomated();
                                    }}
                                >
                                    <Text color="inherit" medium display="inline">
                                        Download Automated Booklet
                                    </Text>
                                </MenuItem>

                                {
                                    (hasBooklet === 1 && useAutoBooklet === 1) &&
                                        <MenuItem
                                            onClick={ () => {
                                                this._handleCloseMenu();
                                                setStatus('manual');
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Use Manual Booklet
                                            </Text>
                                        </MenuItem>
                                }

                                {
                                    useAutoBooklet === 0 &&
                                        <MenuItem
                                            onClick={ () => {
                                                this._handleCloseMenu();
                                                setStatus('automated');
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Use Automated Booklet
                                            </Text>
                                        </MenuItem>
                                }

                                <MenuItem
                                    onClick={ () => {
                                        this._handleCloseMenu();
                                        setStatus('disable');
                                    }}
                                >
                                    <Text color="inherit" medium display="inline">
                                        Disable Booklets
                                    </Text>
                                </MenuItem>
                            </Menu>
                        </div>
                }
            </BlockRow>
        );
    }
}

export default BookletRow;